import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "guide"]

  connect() {
    this.show()
  }

  show() {
    const category = this.categoryTarget.value

    this.guideTargets.forEach((guide) => {
      guide.querySelector("details").open = false
      const visible = guide.dataset.category === category
      guide.hidden = !visible
      guide.setAttribute("aria-hidden", String(!visible))
    })
  }
}
